'use strict';

const jQuery = require('jquery');

const RequestHandler = require('./../../../core/requestHandler');

let fonts = null;

module.exports.getFonts = () => {
    let currentApiUrl = RequestHandler.getBaseUrl();
    let dfd = jQuery.Deferred();

    if (null !== fonts) {
        dfd.resolve(fonts);
    } else {
        RequestHandler.setBaseUrl('/api');
        RequestHandler.read('design/fonts').done((data) => {
            let defaultFont = jQuery('body').css('font-family');
            let included = false;

            data.map((font) => {
                let {label} = font;

                if (font.value === defaultFont) {
                    label = 'Default';
                    included = true;
                }

                return {label, value: font.value};
            });

            if (!included) {
                data.unshift({label: 'Default', value: defaultFont});
            }

            fonts = data;

            dfd.resolve(fonts);
        });
        RequestHandler.setBaseUrl(currentApiUrl);
    }

    return dfd.promise();
};
